import React, { useState, useEffect, Suspense } from 'react'
import { Link } from 'react-router-dom';
import axios from 'axios'
import { Markup } from 'interweave';
import LoadingBar from 'react-top-loading-bar'
import {Helmet} from "react-helmet";
import InfiniteScroll from "react-infinite-scroller";

import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import Footer from '../Footer/Footer';
import EmptyContent from '../Global/EmptyContent';
import Spinner from '../Global/Spinner';

import styles from '../../App.module.css';
import classes from './Galleries.module.css'

function Galleries() {
    const [progress, setProgress] = useState(0);
    const [playlists, setPlaylists] = useState([]);
    const [hasMore, sethasMore] = useState(true);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        try{
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }catch(ex){}
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/albums.php`)
            .then(res => {
                if(res.data.message !== 'No playlists found') {
                    setPlaylists(res.data);
                    res.data.length < 10 ? sethasMore(false) : sethasMore(true);
                  }else {
                    sethasMore(false);
                  }
          
                  setLoading(true);
                  setProgress(100);
            }).catch(err => {
                console.log(err)
            })
    } , [])

    const loadMore = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/albums.php?page=${page}`)
            .then(res => {
                if(res.data.message !== 'No playlists found') {
                    loading && hasMore && setPlaylists([...playlists, ...res.data]);
                    setpage(page + 1);
                    
                    res.data.length < 10 ? sethasMore(false) : sethasMore(true);
                }else {
                    sethasMore(false);
                }
            }).catch(err => {
                console.log(err)
            })
    }

    return (
        <>
            <Helmet>
                <title>Galleries - Wesharez</title>
                <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
                <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
            </Helmet>
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <Header />
            <div className={styles.main_body}>
                <Suspense fallback="<div>Please wait...</div>">
                    <Sidebar active="galleries" />
                </Suspense>
                <Suspense fallback="<div>Please wait...</div>">
                    <div className={styles.main_content + ` main-content`}>
                        <ins className='adsbygoogle p-4 pb-0'
                            style={{ display: 'block' }}
                            data-ad-client='ca-pub-8126596259429304'
                            data-ad-slot='5153011292'
                            data-ad-format='auto'
                        />
                        <div className={`${classes.galleries_component} galleries_component p-4`}>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className={classes.sec_name}>
                                        <h3>Image Galleries</h3>
                                    </div>
                                    <div className="galleries">
                                        {
                                            playlists.length === 0 ? <EmptyContent /> : playlists && playlists.map &&  <InfiniteScroll
                                                pageStart={0}
                                                loadMore={loadMore}
                                                hasMore={hasMore}
                                                loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                className="row m-0"
                                            >
                                                {
                                                    playlists && playlists.map && playlists.map((playlist, index) => {
                                                        return (
                                                            <div id="gallery-3547" className={classes.gallery} key={index}>
                                                                <div className="gallery-inner">
                                                                    <div className={classes.gallery_thumb}>
                                                                        <Link className="clip-link" data-id="3547" title={playlist.title} to={`/album/${playlist.id}/${playlist.nice_url}`}>
                                                                            <span className="clip">
                                                                                <img src={playlist.picture} alt={playlist.title} />
                                                                            </span>
                                                                        </Link>
                                                                        <div className={classes.playlists_overlay}>
                                                                            <Link className="clip-link" data-id="3547" title={playlist.title} to={`/album/${playlist.id}/${playlist.nice_url}`}></Link>
                                                                            <Link title="View all" to={`/album/${playlist.id}/${playlist.nice_url}`}>View all</Link>
                                                                        </div>
                                                                        <div className={classes.playlists_meta}>
                                                                            <span><i className="fa-solid fa-images"></i></span>
                                                                            <span>{playlist.entries}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className={classes.gallery_data}>
                                                                        <h4 className={classes.gallery_title}>
                                                                            <Link to={`/album/${playlist.id}/${playlist.nice_url}`} title={playlist.title}>{playlist.title}</Link>
                                                                        </h4>
                                                                        <p>{playlist.description}</p>
                                                                        <ul className={classes.stats}>
                                                                            <li>Watched {playlist.views} times</li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </InfiniteScroll>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </Suspense>
            </div>
        </>
    )
}

export default Galleries